<template>
    <div v-bind:class="[`product-family__category-card`, portfolio && `product-family__category-card--${portfolio}`]">
        <a :href="productFilteringUrl" v-bind:class="[`product-family__category-card-link`, isFinishImageMissing && `state-finish-image-missing`]">
            <div class="product-family__img-wrap">
                <img v-if="imageUrl" :src="`${imageUrl}?wid=400&hei=400`" :alt="displayName" class="product-family__category-card-image" />
                <div v-if="isFinishImageMissing" class="product-family__finish-coming-soon">{{ translations.NoVariantImage }}</div>
            </div>
            <div class="product-family__category-card-name">
                {{ displayName }}
            </div>
        </a>
    </div>
</template>

<script lang="ts">
import { IProductFamilyTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'Category',
    props: {
        displayName: {
            type: String,
            default: '',
        },
        productFilteringUrl: {
            type: String,
            default: '',
        },
        imageUrl: {
            type: String,
            default: '',
        },
        isFinishImageMissing: {
            type: Boolean,
        },
        portfolio: {
            type: String,
        },
        translations: {
            type: Object,
            default: {} as IProductFamilyTranslations,
        },
    },
};
</script>
